module.exports = __webpack_public_path__ + "img/borderStarWhite.37f26e11.svg";